import React, { useState, useEffect } from 'react';
import { Button, Space, Breadcrumb, Table } from 'antd';
import { CardLayout, SortableTable, RefCodeEditModal } from 'components/molecules';
import { useRefCode } from 'hooks';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { usePopupManager } from 'react-popup-manager';

export interface LectureStudioProps {}

const LectureStudio = ({}: LectureStudioProps): React.ReactElement => {
   /* ======================================================
   * variables
   * ====================================================== */
   const [tableDatas, setTableDatas] = useState<any[]>();
   const [title] = useState<string>('스튜디오');
   const [fieldName] = useState<string>('lecture_studio');
   const { open } = usePopupManager();
 
 
   const columns: ColumnsType<RefCodeListDto> = [
     {
       key: 'sort',
       width: '70px',
       align: 'center',
     },  
     {
       title: title + '명',
       dataIndex: 'value',
       key: 'value',
       width: 'auto',
       align: 'left',
     },
     {
       title: '사용여부',
       dataIndex: 'status_type',
       key: 'status_type',
       width: '80px',
       align: 'center',
       render: (status_type, record) => {
         return (
           <Button
             type='default'
             onClick={(e) => {
               e.stopPropagation();
 
               refCodeUpdate({ref_code_srl: record.ref_code_srl, status_type: status_type === 'AV'?'HD':'AV'})
             }}
           >{status_type === 'AV' ? 'YES' : 'NO'}</Button>
         )
       }
     }, 
   ];
     
   /* ======================================================
    * hooks
    * ====================================================== */
   const { refCodeList, refCodeInsert, refCodeUpdate, refCodeSort } = useRefCode({field:fieldName});  
 
   /* ======================================================
    * events
    * ====================================================== */    
    const onSort = (active: string | number, over: string | number)  => {
     refCodeSort({active: active as number, over: over as number})
   }
 
   const onClickRegister = () => {
     open(RefCodeEditModal, {
       title: title,
       ref_code_srl: 0,
       onClose: (isOk, value) => {
         if (isOk) {
           refCodeInsert({
             field: fieldName,
             name_alias: 'LS',
             value: value,
           })    
         }
       },
     }); 
   }
 
   const onRowClick = (record: any) => {
     open(RefCodeEditModal, {
       title: title,      
       ref_code_srl: record.ref_code_srl,
       value: record.value,
       onClose: (isOk, value) => {
         if (isOk) {
           refCodeUpdate({ref_code_srl: record.ref_code_srl, value: value})     
         }
       },
     });   
   }  
   /* ======================================================
    * effects
    * ====================================================== */
   useEffect(() => {
     setTableDatas(refCodeList?.map((item) => ({
       ...item,
       key: item.ref_code_srl,
     })));
   }, [refCodeList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>기초정보관리</Breadcrumb.Item>
        <Breadcrumb.Item>강의장소</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <TotalNumMenu text={' '} useRegister onUseRegister={onClickRegister} />
          <SortableTable
            dataList={tableDatas as any[]}
            columns={columns}
            onSort={onSort}
            onClick={onRowClick}
          />          
        </Space>          
    </CardLayout>
  )
};

export default LectureStudio;    